import { Avatar } from "@unified-checkout/design-system";
import { useUserInfoStore } from "@app/dashboard/store/userInfo";
import styles from "./business-info-box.module.scss";

export const BusinessInfoBox = () => {
  const { userInfo } = useUserInfoStore();

  const { logo, companyName, shortName } = userInfo;

  return (
    <div className={styles['business-info']}>
      <Avatar
        {
        ...(
          logo ?
            {
              type: 'img',
              imgUrl: logo
            }
            :
            {
              type: 'text',
              shortName: shortName
            }
        )
        }
        focusable={false}
      />
      <span title={companyName}>
        {companyName}
      </span>
    </div>
  )
};